import PropTypes from 'prop-types'
import React from 'react'
import { canUser } from '../../../../common/utils/userAuthorization'

import styles from './adminLink.module.css'

class AdminLink extends React.Component {
  static propTypes = {
    user: PropTypes.object
  }

  render () {
    const { user } = this.props

    if (canUser(user, 'canViewAdmin')) {
      return (
        <li className={styles.item}>
          <a href='/admin' className={styles.link}>
            <span className={styles.text}>
              Admin
            </span>
          </a>
        </li>
      )
    } else {
      return null
    }
  }
}

export default AdminLink



// WEBPACK FOOTER //
// ./client/components/siteHeader/header/adminLink.js